import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HearingDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hearing_disabled"}/>
}
